{
    "Action.AddComment": "Lägg till kommentar",
    "Action.Close": "Stäng",
    "Action.CloseAll": "Stäng alla",
    "Action.ClosePanel": "Stäng panel",
    "Action.CloseTab": "Stäng flik",
    "Action.DeleteComment": "Ta bort kommentar",
    "Action.DeleteFilling": "Radera ifyllning",
    "Action.DuplicateFilling": "Duplicera ifyllning",
    "Action.EditComment": "Ändra kommentar",
    "Action.EditFilling": "Redigera ifyllning",
    "Action.ExpandTitle": "Expandera {{title}}",
    "Action.Generate": "Generera",
    "Action.GenerateChecklist": "Generera checklista",
    "Action.GenerateTemplates": "Generera mallar",
    "Action.GenerateToWord": "<small-1>Generera till<\/small-1> Word",
    "Action.NameFilling": "Namnge ifyllning",
    "Action.NewFilling": "Ny ifyllning",
    "Action.OpenAll": "Öppna alla",
    "Action.OpenFilling": "Öppna ifyllning",
    "Action.OpenInDib": "Öppna i dib",
    "Action.OpenMenu": "Öppna meny",
    "Action.Reset": "Nollställ",
    "Action.ResetFields": "Återställ fälten",
    "Action.Save": "Spara",
    "Action.SendToDflow": "<small-1>Skicka till<\/small-1> dflow",
    "Action.WriteAComment": "Skriv en kommentar",
    "Dashboard.pin": "Infoga innehållet",
    "Dashboard.pinToTop": "Fäst vid toppen",
    "Dashboard.removeFavorite.title": "Ta bort från favoriter",
    "Dashboard.removeFromTop": "Ta bort från toppen",
    "Dashboard.unpin": "Ta bort fäst innehåll",
    "Dashboard.unpin.confirm.title": "Ta bort fäst innehåll?",
    "DocumentGenerator.Alternative": "Alternativ",
    "DocumentGenerator.ChooseAlternative": "Välj ett alternativ",
    "DocumentGenerator.OptionalContent": "Valfritt innehåll",
    "Error.404Description": "Sidan du efterfrågade finns inte",
    "Error.FetchFillings": "Det gick inte att hämta fyllningar",
    "Error.NoFillingAccess": "Du har inte åtkomst till denna ifyllning",
    "Error.NotFound": "Hittades inte",
    "Error.SomethingWentWrong": "Något gick fel",
    "Error.TryReloadingOrContactUs": "Vänligen prova att ladda sidan igen, och <span-1><a-1>kontakta oss<\/a-1> om problemet kvarstår.<\/span-1>",
    "Error.UnknownArtifact": "422 Innehållet kan inte visas",
    "Info.ChooseADocumentToTheLeft": "Välj ett dokument till vänster",
    "Info.DataToDuplicate": "Data som ska dupliceras",
    "Info.FillingWithoutName": "Ifyllning utan namn",
    "Info.GenerationNotAvailableForDemoUsers": "Du kan inte generera dokument som demoanvändare.",
    "Info.IncludeInGeneration": "Inkludera i generering",
    "Info.MergeDocuments": "Slå samman valda dokument till en pdf.",
    "Info.NoAvailableDocuments": "Inga tillgängliga dokument",
    "Info.NoHits": "Inga resultat",
    "Info.RemoveFromGeneration": "Ta bort från generering",
    "Label.ConfirmAction": "Bekräfta åtgärd",
    "Label.DIBStandardTemplate": "DIB Standardmall",
    "Label.DuplicateName": "Kopierat namn",
    "Label.MarkAllAsStatus": "Markera hela kategorin som {{status}}",
    "Label.ShowLess": "Visa mindre",
    "Label.ShowMore": "Visa mer",
    "Navigation.Lookup": "Slå upp",
    "Phrase.AsEmailAttachment": "Som bifogad fil i e-post",
    "Phrase.AvailableOnDib": "Tillgänglig på dib",
    "Phrase.ChooseStyleTemplate": "Välj formatmall",
    "Phrase.ChooseStyleTemplatePrompt": "Välj formatmall",
    "Phrase.DeliveredAs": "Levereras som",
    "Phrase.DownloadFile": "Ladda ned {{file}}",
    "Phrase.DuplicateOfTitle": "Kopia av {{fillingTitle}}",
    "Phrase.FieldsInDocumentGenerator": "Fält i dokumentgenerator",
    "Phrase.InAWordDocument": "I ett Word-dokument",
    "Phrase.IncludeInstructions": "Inkludera vägledning",
    "Phrase.LastEdited": "Senast ändrad",
    "Phrase.LoadingModal": "Laddar...",
    "Phrase.NoAccess": "Ingen åtkomst",
    "Phrase.NoPreviousFillings": "Inga tidigare ifyllningar",
    "Phrase.NoResultsOn": "Inga resultat på",
    "Phrase.NoSearchResults": "Ingen träff",
    "Phrase.NoTemplatesChosen": "Inga mallar markerade",
    "Phrase.RemoveFilters": "Rensa filter",
    "Phrase.SearchFilling": "Sök ifyllning",
    "Phrase.SendToDflow": "Skicka till dflow",
    "Phrase.ShowMore": "Visa mer",
    "Phrase.SorryYouDoNotHaveAccessToContent": "<strong-1>Beklagar<\/strong-1>, du har inte tillgång till det här innehållet",
    "Prompt.WouldYouLikeToDeleteFilling": "Vill du radera <strong-1>{{fillingTitle}}<\/strong-1>?",
    "Status.Deviation": "Avvikelse",
    "Status.NA": "Ej aktuellt",
    "Status.Ok": "OK",
    "Status.Todo": "Att göra",
    "Status.WithComment": "Med kommentar",
    "Title.LabelOfContents": "Innehållsförteckning",
    "Title.RelatedContent": "Relaterat",
    "Title.TemplatesWithCount": "Mallar ({{selectedDocsLength}})",
    "Type.AuditTemplate": "Revisionsmall",
    "Type.ChartOfAccounts": "Kontoplan",
    "Type.ChecklistTemplates": "Checklista",
    "Type.Decision": "Beslut",
    "Type.Directive": "Direktiv",
    "Type.Function": "Funktion",
    "Type.Handbook": "Handbok",
    "Type.JuridiskVejledning": "Juridisk Vejledning",
    "Type.Law": "Lag",
    "Type.LegalCommentary": "Lagkommentar",
    "Type.Literature": "Facklitteratur",
    "Type.Nature": "Art",
    "Type.News": "Nyhet",
    "Type.PortalReference": "Portal",
    "Type.PortalSources": "Portal",
    "Type.PortalTools": "Portal",
    "Type.Praktika": "Praktika",
    "Type.PreparatoryWorks": "Förarbeten",
    "Type.Q&A": "Q&A",
    "Type.Regulation": "Förordning",
    "Type.SkatteABC": "Skatte-ABC",
    "Type.Spreadsheet": "Kalkylblad",
    "Type.Standard": "Standard",
    "Type.Statement": "Uttalande",
    "Type.TaxTreaty": "Skatteavtal",
    "Type.Template": "Dokumentmall",
    "Type.Topic": "Ämne",
    "Type.Unknown": "Annat",
    "Warn.DataToDuplicateNotChosen": "Du har inte valt någon data för duplicering",
    "Warning.AboutToMarkAllChecklistItems": "Du är på väg att välja alla punkter i checklistan i den här kategorin som <strong>{{status}}<\/strong>. Är du säker?",
    "Widget.audit.process.title": "Revision - Mallar och Checklistor",
    "Widget.content.description": "Innehåll i dib jag har besökt",
    "Widget.content.none": "Ingenting här... Saker dyker upp så fort du öppnar innehåll",
    "Widget.content.title": "Senast besökt",
    "Widget.favourites.title": "Mina favoriter",
    "Widget.fillings.description": "Mallar och checklistor jag arbetar med",
    "Widget.fillings.none": "Inga ifyllningar här... Börja fylla i checklistor och mallar så dyker det upp saker här.",
    "Widget.fillings.title": "Ifyllningar",
    "Widget.internal.portal.allAreas": "Alla områden",
    "Widget.internal.portal.content": "Innehåll",
    "Widget.internal.portal.history": "Historik",
    "Widget.internal.portal.history.none": "Innehåll du öppnar visas här.",
    "Widget.internal.portal.myWork": "Mitt arbete",
    "Widget.internal.portal.myWork.none": "Sparade fyllningar kommer att visas här",
    "Widget.internal.portal.pinned": "Fastnat",
    "Widget.internal.portal.title": "Portaler",
    "Widget.internal.templates.title": "Senaste mallar",
    "Widget.last.threads.none": "Dina konversationer och sökningar kommer att visas här",
    "Widget.last.threads.title": "Senaste trådar",
    "Widget.latest.news.title": "Nyheter",
    "Widget.threads.description": "Senaste chattar\/trådar med KAI",
    "Widget.threads.none": "Ingenting här.. När du börjar söka\/chatta så dyker det upp saker här",
    "Widget.threads.title": "Samtal",
    "Word.Abort": "Avbryt",
    "Word.Checklist": "Checklista",
    "Word.Close": "Stäng",
    "Word.Comments": "Kommentarer",
    "Word.Confirm": "Bekräfta",
    "Word.Content": "Innehåll",
    "Word.Created": "Skapad",
    "Word.DocumentType": "Dokumenttyp",
    "Word.Duplicate": "Duplicera",
    "Word.Edit": "Ändra",
    "Word.Email": "E-post",
    "Word.Error": "Fel",
    "Word.Filling": "Ifyllning",
    "Word.Footnote": "Fotnot",
    "Word.Generate": "Generera",
    "Word.Info": "Info",
    "Word.Landscape": "Liggande",
    "Word.Less": "Mindre",
    "Word.More": "Mer",
    "Word.Name": "Namn",
    "Word.New": "Ny",
    "Word.Open": "Öppna",
    "Word.PaperOrientation": "Orientering",
    "Word.Portrait": "Stående",
    "Word.Remove": "Ta bort",
    "Word.Sources": "Källor",
    "Word.Status": "Status",
    "Word.StyleTemplate": "Formatmall",
    "Word.Template": "Mall",
    "Word.Templates": "Mallar",
    "Word.TheSearchText": "Söktexten",
    "Word.Untitled": "Utan titel",
    "Word.ZipFile": "ZIP-fil",
    "Word.create": "Skapa",
    "action.seeLess": "Visa mindre",
    "action.seeMore": "Visa mer",
    "alert.MergeConfirmBody": "Genom att kryssa i \"PDF-sammanslagning\" kommer alla valda dokument att slås samman till ett PDF-dokument. De kommer inte att kunna redigeras i Dflow.",
    "alert.MergeConfirmTitle": "PDF-sammanslagning",
    "animation.part.0": "Fråga",
    "animation.part.1": "KAI",
    "animation.part.2": "om",
    "animation.suggestion.1": "IFRS",
    "animation.suggestion.2": "redovisning",
    "animation.suggestion.3": "innehåll i dib",
    "app.title": "KAI",
    "artifact.emailDraft.copied": "Kopierat!",
    "artifact.emailDraft.copyEmail": "Kopiera e-post",
    "artifact.emailDraft.empty": "Tomt e-postutkast",
    "artifact.emailDraft.openInClient": "Öppna i e-postklient",
    "artifact.emailDraft.subjectLabel": "Ämne",
    "artifact.emailDraft.titleFallback": "E-postutkast",
    "artifact.emailDraft.tooLongWarning": "E-postmeddelandet är för långt för att skicka direkt via e-postklienten. Använd kopieringsknappen för att kopiera innehållet och klistra in det manuellt.",
    "artifact.generic.titleFallback": "Artefakt",
    "artifact.pending.titleFallback": "Utkast",
    "artifact.searchResults.noResults": "Inga resultat för \"{{query}}\"",
    "artifact.searchResults.resultsFor": "Resultat för \"{{query}}\"",
    "artifact.searchResults.showFewer": "Visa färre",
    "artifact.searchResults.showMore": "Visa {{count}} fler resultat",
    "artifact.searchResults.titleFallback": "Sökresultat",
    "assistant.answerHeading": "Svar från KAI",
    "brand.name": "DIB",
    "callout.suggestplus.common.confirm": "Fråga igen med KAI+",
    "callout.suggestplus.common.text": "Vill du göra en djupare analys med lite längre väntetid?",
    "callout.suggestplus.common.title": "KAI kan inte ge ett tillräckligt bra svar",
    "chat.ephemeral_search.nudge": "Är inte resultaten ovan relevanta? Fortsätt chatta med mig nedan",
    "chat.experimentalEngineActive": "Experimentell motor",
    "chat.limit.body": "För att säkerställa att KAI ger dig precisa svar avslutas konversationer efter 50 meddelanden.",
    "chat.limit.button": "Starta nytt samtal",
    "chat.limit.heading": "Maxgränsen är nådd",
    "chat.multi_stream.capacity_message": "Tre konversationer behandlas redan. Vänta tills en har slutförts.",
    "chat.multi_stream.capacity_title": "För många aktiva konversationer",
    "common.askQuestion": "Ställ en fråga",
    "common.cancel": "Avbryt",
    "common.closeSidebar": "Stäng sidofält",
    "common.collapseSidebar": "Stäng sidopanel",
    "common.copied": "Kopierad",
    "common.copy": "Kopiera",
    "common.defaultThreadTitle": "Ny tråd",
    "common.delete": "Radera",
    "common.disclaimer": "Svar från KAI kan innehålla fel.",
    "common.editMessage": "Redigera meddelande",
    "common.expandSidebar": "Öppna sidopanel",
    "common.getStarted": "Ställ en fråga för att komma igång!",
    "common.goBack": "Gå tillbaka",
    "common.loadingTranslations": "Laddar översättningar...",
    "common.malerAndChecklists": "Mallar och checklistor",
    "common.newChat": "Ny fråga",
    "common.noResults": "Inga sökträffar",
    "common.openSidebar": "Öppna sidofält",
    "common.otherContentFromDIB": "Annat innehåll från dib",
    "common.recentChats": "Senaste trådar",
    "common.recentSearches": "Senast besökt i dib",
    "common.recentThreads": "Senaste trådarna",
    "common.regenerate": "Regenerera svar",
    "common.rename": "Byt namn",
    "common.save": "Spara",
    "common.search": "Sök",
    "common.searchBox": "Fråga <strong>KAI<\/strong> eller sök efter innehåll",
    "common.seeAll": "Se alla",
    "common.send": "Skicka",
    "common.share": "Dela",
    "common.showAll": "Visa alla ({{count}})",
    "common.showLess": "Visa färre",
    "common.suggestions": "Förslag",
    "common.thinking": "Tänker... AI-svar är inte alltid felfria. Kom ihåg att kontrollera källorna från dib!",
    "common.tryAgain": "Försök igen",
    "common.visibleForAdmins": "Synlig för admin",
    "common.yesterday": "I går",
    "content.comment": "Kommentar",
    "content.lawRulesMirror": "Lag\/föreskriftsspegel",
    "content.relatedSources": "Relaterade källor",
    "content.tags": "Nyckelord",
    "content.translation": "Översättning",
    "contextSidebar.BetaDisclaimer": "Sidopanelen är under utveckling. Vi arbetar löpande med att hämta bra sökresultat från dib.",
    "contextSidebar.OtherHeading": "Annat innehåll från dib",
    "contextSidebar.ThreadExplanation": "Chattbeskrivning (AI-genererad)",
    "contextSidebar.ToolsHeading": "Verktyg från dib",
    "contextSidebar.closeContextSidebar": "Stäng kontext-sidofält",
    "contextSidebar.error": "Fel vid laddning av innehåll",
    "contextSidebar.noRelatedContent": "Inga relaterade ämnen eller källor hittades i dib",
    "contextSidebar.noRelatedTemplates": "Inga tillhörande mallar eller checklistor hittades i dib",
    "contextSidebar.openContextSidebar": "Öppna sidopanelen",
    "date.last30Days": "Senaste 30 dagarna",
    "date.lastWeek": "Senaste veckan",
    "date.previously": "Tidigare",
    "date.today": "Idag",
    "debug.addSuggestion": "Lägg till förslag",
    "error.contentFilter.body": "Frågan blockerades av innehållsfiltret. Redigera ditt meddelande ovan och försök med andra ord.",
    "error.contentFilter.title": "Innehållsfiltrering",
    "error.contextLength.body": "Chatten har blivit för lång.",
    "error.contextLength.title": "Chatt för lång",
    "error.filteredContent.body": "Svaret filtrerades bort på grund av att din fråga utlöste vår innehållspolicy. Vänligen redigera din fråga och försök igen.",
    "error.interrupted.body": "Det föregående svaret slutfördes inte. Försök med frågan igen för att få ett nytt svar.",
    "error.interrupted.title": "Svaret avbröts",
    "error.rateLimit.body": "Du har nått gränsen för antal förfrågningar. Vänta några minuter och försök igen. Om problemet kvarstår, kontakta kundsupport.",
    "error.rateLimit.title": "För många förfrågningar",
    "error.unknown.body": "Ett okänt fel inträffade när svaret skulle genereras.",
    "error.unknown.title": "Okänt fel",
    "file.download": "Ladda ned {{file}}",
    "file.downloadNotForDemo": "Filnedladdning är inte tillgängligt för demoanvändare",
    "forbidden.description": "Tyvärr har du inte behörighet att använda den här applikationen. Vänligen kontakta oss om du anser att detta är ett fel.",
    "forbidden.title": "Åtkomst nekad",
    "input.placeholder.splash": "Vad behöver du hjälp med?",
    "input.placeholder.thread": "Ställ en uppföljningsfråga",
    "menu.item.desc.deep": "Analyserar och resonerar mer",
    "menu.item.desc.fast": "KAI ger dig enkla, snabba svar",
    "menu.item.disabledtooltip.deep": "Den här funktionen är inte tillgänglig för dig.",
    "menu.item.time.deep": "~20 sek",
    "menu.item.time.fast": "~10 sek",
    "menu.item.title.deep": "KAI+",
    "menu.item.title.fast": "Snabba svar",
    "name.Dflow": "Dflow",
    "prompt.heading.welcome": "Vad kan jag hjälpa dig med?",
    "rag.state.answering": "Svarar",
    "rag.state.finished": "Tänkte i {n} sekunder",
    "rag.state.finishedNoTime": "Sammanfattning",
    "rag.state.idle": "Tänker",
    "rag.state.reading": "Läser innehåll",
    "rag.state.searching": "Söker i källorna",
    "rag.state.summarizing": "Sätter ihop relevanta källor",
    "rating.addRating": "Ge feedback",
    "rating.comment.placeholder": "Kommentar",
    "rating.editRating": "Ändra feedback",
    "rating.modal.button": "Skicka feedback",
    "rating.modal.cancel": "Hoppa över",
    "rating.modal.category.0": "Svaret innehåller fel",
    "rating.modal.category.1": "KAI följde inte mina instruktioner",
    "rating.modal.category.2": "Jag var inte nöjd med strukturen i svaret",
    "rating.modal.category.3": "KAI använder fel källor från dib",
    "rating.modal.category.4": "Annan feedback",
    "rating.modal.category.5": "Föråldrad information",
    "rating.modal.description": "Välj den kategori som passar bäst för din feedback. Detaljerad feedback gör att vi kan förbättra KAI.",
    "rating.modal.elaborate": "Förklara gärna mer...",
    "rating.modal.title": "Tack för din feedback",
    "rating.response.isHelpful": "Bedöm svar som hjälpsamt",
    "rating.response.isNotHelpful": "Bedöm svar som ej hjälpsamt",
    "rating.submit": "Skicka",
    "rating.text": "Lämna en kommentar",
    "references.consideredSources.title": "Dessutom sökte KAI igenom dessa källor:",
    "references.consideredSources.tooltip": "Visa andra övervägda källor",
    "references.relatedTools.title": "Föreslagna verktyg",
    "references.title": "Svaret är baserat på dessa källor från DIB",
    "reflections.button.text": "Reflektioner",
    "reflections.button.text.loading": "Analyserar frågan",
    "rename.modal.label": "Nytt namn",
    "rename.modal.title": "Byt namn på tråd",
    "sessionExpired.description": "Din session avslutades och vi kunde inte starta den automatiskt igen. Försök att logga in på nytt. Om detta fortsätter, vänligen kontakta support.",
    "sessionExpired.signOut": "Logga ut",
    "sessionExpired.title": "Sessionen har löpt ut",
    "settings.accountDetails": "Kontoinställningar",
    "settings.chatEngine": "Chattmotor",
    "settings.field.chatEngine.experimental": "Experimentell",
    "settings.field.chatEngine.standard": "Standard",
    "settings.field.company.description": "Ditt företag",
    "settings.field.company.title": "Företag",
    "settings.field.email.description": "Din e-post",
    "settings.field.email.title": "E-post",
    "settings.field.name.description": "Ditt namn",
    "settings.field.name.title": "Namn",
    "settings.field.response.deep": "KAI+",
    "settings.field.response.fast": "Snabb",
    "settings.field.sidebarPosition.left": "Vänster",
    "settings.field.sidebarPosition.right": "Höger",
    "settings.language": "Språk",
    "settings.logout": "Logga ut",
    "settings.preferences": "Inställningar",
    "settings.responseType": "Förvald svarstyp",
    "settings.showInternalFeatures": "Visa adminfunktionalitet",
    "settings.sidebarPosition": "Kontext-sidofält position",
    "settings.title": "Inställningar",
    "suggestionQuestion.1": "Hur påverkar IFRS 16 företagets nyckeltal och finansiella rapportering?",
    "suggestionQuestion.2": "Hur ska negativ goodwill redovisas och beskattas enligt K3?",
    "table.close": "Stäng",
    "table.expand": "Expandera",
    "table.fullscreenTitle": "Stäng helskärm med krysset längst till höger, eller tryck på <span>Esc<\/span> knappen.",
    "table.openFullscreen": "Öppna tabellen i helskärm",
    "thread.postsearch.filters.button": "Filter",
    "thread.postsearch.filters.otherSources": "Källor",
    "thread.postsearch.filters.tools": "Verktyg",
    "thread.postsearch.note": "<strong>Träffar inte sökningen som förväntat?<strong><\\br> Vi arbetar ständigt med att göra resultaten från DIB mer relevanta",
    "thread.postsearch.resultsFor": "Sökresultat för",
    "thread.tabs.answer": "Svar från KAI",
    "thread.tabs.answerReady": "Svar klart",
    "thread.tabs.search": "Träffar i DIB",
    "topicSidebar.OtherHeading": "Annat innehåll",
    "topicSidebar.ToolsHeading": "Verktyg",
    "userinput.button.text.deep": "KAI+",
    "userinput.button.text.fast": "Snabb",
    "userinput.placeholder": "Fråga KAI",
    "word.Expand": "Expandera"
}